
/**
 * ConveniView.js
 */

class ConveniView {

    constructor( dataObj ) {

        this._VIEW_STATE = [ 'front', 'custom', 'pred', 'result' ];
        this._VIEW_STATE_BOO = [ true, false, false, false ];

        this.parentObj = dataObj;
        this.useData = {};
        this.useData['nbResult'] = dataObj['nbResult'];

        this.conveniPool = new ConveniPoolOp();

        this.jikuBoo = MyUtility.makeFillArraySetVal( 11, false, 10, true);
        this.jyoBoo = MyUtility.makeFillArraySetVal( 11, false, 10, true);

        this.setCustomBtSttyle( 'jiku', this.jikuBoo);
        this.setCustomBtSttyle( 'jyo', this.jyoBoo);

        this.targetArray = [ 1,3,5,10 ];
        this.targetBooArray = [  false, false, true, false  ];
        this.setCustomBtSttyle( 'target', this.targetBooArray );

        this.isJustTargetArray = [ false, true ];
        this.setCustomBtSttyle( 'just', this.isJustTargetArray );

        this.processTypeValueArray = [ 0.8, 0.65, 0.55 ];
        this.processTypeArray = [ false, true, false ];
        this.setCustomBtSttyle( 'process', this.processTypeArray );


        //
        this._pick3Array = [];


        //  theme
        let defState = StorageOperator.getStorageData('session', 'state');
        let themeInd = defState.theme ? defState.theme : 0;
        //  canvas
        this._canvas = new ConveniCanvas( themeInd );



        //  state

        this._conveniStateObj = {};
        let state = StorageOperator.getStorageData('session', 'conveni-state');
        if(state) {
            this._conveniStateObj = state;
            if(state.viewState[0]) {

                this.setViewDiv();

            }else if(state.viewState[1]) {

                let or34 = state.nb34 ? state.nb34: 3;

                this.setCustomBooForStorage( this._conveniStateObj );

                this.setOr34(or34, false, false);

                this.setViewDiv();
            
            }else if(state.viewState[2]) {
                let or34 = state.nb34 ? state.nb34: 3;

                this.setCustomBooForStorage( this._conveniStateObj );

                this.setOr34(or34, true, false);

                //this.customNextProcess(false);

                this.setViewDiv();

            }else if(state.viewState[3]) {
                let or34 = state.nb34 ? state.nb34: 3;

                this.setCustomBooForStorage( this._conveniStateObj );

                this.setOr34(or34, false, false);

                this.customNextProcess(false, false);

                let resultList = [];
                if(this._conveniStateObj.resultList) {  resultList = this._conveniStateObj.resultList;  };

                this.setResultListSize( resultList );

                this.setViewDiv();
                this.setResultTable( resultList );

            };
        }else {
            this._conveniStateObj.viewState = this._VIEW_STATE_BOO;

            try {
                StorageOperator.setStorageData( 'session', 'conveni-state', this._conveniStateObj );
            }catch(exeption) {
                this.storageAlertProcess();
            };
            this.setViewDiv();
        };

        //  add event
        this.addEventListener();
    };



    storageAlertProcess() {
        alert('ストレージの取得ができませんでした、お手数ですがページの更新をしてください');
    };

    conveniStateObjToString() {
        return 'nb34: '+this._conveniStateObj.nb34+'\nview: '+this._conveniStateObj.viewState+'\njiku: '+this._conveniStateObj.customJiku
                +'\njyo: '+this._conveniStateObj.customJyo+'\ntarget'+this._conveniStateObj.targetBoo
    };

    setCustomBooForStorage( conveniStateObj ) {

        if(conveniStateObj.viewState) MyUtility.printArray( this._VIEW_STATE_BOO, conveniStateObj.viewState);
        if(conveniStateObj.customJiku) MyUtility.printArray( this.jikuBoo, conveniStateObj.customJiku);
        if(conveniStateObj.customJyo) MyUtility.printArray( this.jyoBoo, conveniStateObj.customJyo);
        if(conveniStateObj.targetBoo) MyUtility.printArray( this.targetBooArray, conveniStateObj.targetBoo);
        if(conveniStateObj.justBoo) MyUtility.printArray( this.isJustTargetArray, conveniStateObj.justBoo);

        if(conveniStateObj.process) MyUtility.printArray( this.processTypeArray, conveniStateObj.process);

        this.setCustomBtSttyle( 'jiku', this.jikuBoo);
        this.setCustomBtSttyle( 'jyo', this.jyoBoo);
        this.setCustomBtSttyle( 'target', this.targetBooArray );
        this.setCustomBtSttyle( 'just', this.isJustTargetArray );

        this.setCustomBtSttyle( 'process', this.processTypeArray );
    };



    setViewDiv() {
        for(let i=0, n=this._VIEW_STATE_BOO.length; i<n; i++) {
            if(this._VIEW_STATE_BOO[i]) {
                MyUtility.setElementStyle( this._VIEW_STATE[i], 'display', 'block');
            }else {
                MyUtility.setElementStyle( this._VIEW_STATE[i], 'display', 'none');
            }
        };
    };

    setViewStateBoo(index) {
        MyUtility.setFillArray(this._VIEW_STATE_BOO, false);
        this._VIEW_STATE_BOO[index] = true;
    };




    addEventListener() {

        MyUtility.setElementEvent( 'bt3', 'click', ()=> this.setOr34(3) );
        MyUtility.setElementEvent( 'bt4', 'click', ()=> this.setOr34(4) );
        this.setCustomBtLisner( 'jiku', this.jikuBoo, this.jyoBoo);
        this.setCustomBtLisner( 'jyo', this.jyoBoo, this.jikuBoo);
        MyUtility.setElementEvent( 'custom-next-bt', 'click', ()=> this.customNextProcess() );

        this.setTargetBtListener();
        this.setIsJustTargetBtListener();

        this.setProcessBtListener();

        //predict
        for(let i=0; i<3; i++) {
            MyUtility.setElementEvent( 'canvasBt-'+(i+1), 'click', ()=> this.predictPick3Choice(i) );
        };
        MyUtility.setElementEvent( 'canvasBt-pass', 'click', ()=> this.predictPassBtProcess() );
        MyUtility.setElementEvent( 'canvasBt-return', 'click', ()=> this.predictReturnBtProcess() );
        
        MyUtility.setElementEvent( 'process-return-bt', 'click', () => this.returnProcess() );

        //  theme
        MyUtility.setElementEvent( 'theme-bt', 'click', () => this.themeChange() );

    };



    //  or34
    setOr34(or34, isState=true, isCustomBtClear=true) {
        if(or34===3) {
            this.useData['highPool'] = this.parentObj['highPool3'];
            this.useData['high2Pool'] = this.parentObj['high2Pool3'];
        }else {
            this.useData['highPool'] = this.parentObj['highPool4'];
            this.useData['high2Pool'] = this.parentObj['high2Pool4'];
        };

        document.getElementById('label-nb34').textContent = or34===3 ? 'Numbers 3': 'Numbers 4';

        if(isCustomBtClear) {  this.customBtClear();  };

        if(isState) {
            MyUtility.setElementStyle('front', 'display', 'none');
            MyUtility.setElementStyle('custom', 'display', 'block');
    
            //  state
            this._conveniStateObj.nb34 = or34;
            MyUtility.setFillArray(this._VIEW_STATE_BOO, false);
            this._VIEW_STATE_BOO[1] = true;
            this._conveniStateObj.viewState = this._VIEW_STATE_BOO;

            this._conveniStateObj.customJiku = this.jikuBoo;
            this._conveniStateObj.customJyo = this.jyoBoo;
            this._conveniStateObj.targetBoo = this.targetBooArray;
            this._conveniStateObj.justBoo = this.isJustTargetArray;

            this._conveniStateObj.process = this.processTypeArray;

            try {
                StorageOperator.setStorageData( 'session', 'conveni-state', this._conveniStateObj );
            }catch(exeption) {
                //alert('お使いのブラウザでは、本サイトは正常に動作しない可能性があります');
            };
        };
    };


    customBtClear() {

        MyUtility.setFillArray( this.jikuBoo, false );
        this.jikuBoo[10] = true;
        MyUtility.setFillArray( this.jyoBoo, false );
        this.jyoBoo[10] = true;
        MyUtility.setFillArray( this.targetBooArray, false );
        this.targetBooArray[2] = true;
        MyUtility.setFillArray( this.isJustTargetArray, false );
        this.isJustTargetArray[1] = true;

        MyUtility.setFillArray( this.processTypeArray, false );
        this.processTypeArray[1] = true;

        this.setCustomBtSttyle( 'jiku', this.jikuBoo);
        this.setCustomBtSttyle( 'jyo', this.jyoBoo);
        this.setCustomBtSttyle( 'target', this.targetBooArray );
        this.setCustomBtSttyle( 'just', this.isJustTargetArray );

        this.setCustomBtSttyle( 'process', this.processTypeArray );
    };



    //  custum button
    setCustomBtLisner(categ, booArr, bindBooArr) {
        for(let i=0, n=booArr.length; i<n; i++) {
            if(categ==='jiku') {  MyUtility.setElementEvent( categ+'-'+i, 'click', this.jikuBtClick(booArr, bindBooArr, i, this) );  };
            if(categ==='jyo') {  MyUtility.setElementEvent( categ+'-'+i, 'click', this.jyoBtClick(booArr, bindBooArr, i, this) );  };
        };
    };
    jikuBtClick(booArray, bindBooArray, index, parent) {
        //let booArray = booArr;
        //let bindBooArray = bindBooArr;
        return function() {
            MyUtility.setFillArray(booArray, false);
            booArray[index] = true;
            if(index<10) {
                bindBooArray[index] = false;
                let bindBooState = false;
                for(let i=0; i<10; i++) {  if(bindBooArray[i]) {  bindBooState = true;  };  };
                bindBooArray[10] = bindBooState ? false : true;
                parent.setCustomBtSttyle('jyo', bindBooArray);
            };
            parent.setCustomBtSttyle('jiku', booArray);
        };
    };
    jyoBtClick(booArray, bindBooArray, index, parent) {
        //let booArray = booArr;
        //let bindBooArray = bindBooArr;
        return function() {
            let count = MyUtility.arrayCount( booArray, true );
            if(count===1) {
                if(index===10) {
                    MyUtility.setFillArray(booArray, false);
                    booArray[index] = true; 
                }else {
                    if(booArray[10]) {
                        MyUtility.setFillArray(booArray, false);
                        booArray[index] = true;
                        if(index<10) {
                            bindBooArray[index] = false;
                            let bindBooState = false;
                            for(let i=0; i<10; i++) {  if(bindBooArray[i]) {  bindBooState = true;  };  };
                            bindBooArray[10] = bindBooState ? false : true;
                            parent.setCustomBtSttyle('jiku', bindBooArray);
                        };
                    }else {
                        booArray[index] = true;
                        if(index<10) {
                            bindBooArray[index] = false;
                            let bindBooState = false;
                            for(let i=0; i<10; i++) {  if(bindBooArray[i]) {  bindBooState = true;  };  };
                            bindBooArray[10] = bindBooState ? false : true;
                            parent.setCustomBtSttyle('jiku', bindBooArray);
                        };
                    };
                };
            }else {
                if(index===10) {
                    MyUtility.setFillArray(booArray, false);
                    booArray[index] = true;
                }else {
                    booArray[index] = false;
                };
            };
            parent.setCustomBtSttyle('jyo', booArray);
        };
    };
    setCustomBtSttyle(categ, booArr) {
        for(let i=0, n=booArr.length; i<n; i++) {
            let bcColor = booArr[i] ? '#0077d0' : "#eeeeff";
            let color = booArr[i] ? '#ffffff' : "#0000aa";
            MyUtility.setElementStyle( categ+'-'+i, 'background-color', bcColor );
            MyUtility.setElementStyle( categ+'-'+i, 'color', color );
        };
    };
    //  custum button  end

    //  target button
    setTargetBtListener() {
        for(let i=0, n=this.targetArray.length; i<n; i++) {
            MyUtility.setElementEvent( 'target-'+i, 'click', () => this.targetBtClick( i ) );
        };
    };
    targetBtClick(index) {
        MyUtility.setFillArray( this.targetBooArray, false);
        this.targetBooArray[index] = true;
        this.setCustomBtSttyle( 'target', this.targetBooArray);
    };

    // isJustTarget
    setIsJustTargetBtListener() {
        MyUtility.setElementEvent( 'just-0', 'click', () => this.isJustTargetBtClick( 0 ) );
        MyUtility.setElementEvent( 'just-1', 'click', () => this.isJustTargetBtClick( 1 ) );
    };
    isJustTargetBtClick( index ) {
        MyUtility.setFillArray( this.isJustTargetArray, false);
        this.isJustTargetArray[index] = true;
        this.setCustomBtSttyle( 'just', this.isJustTargetArray);
    };

    //  processType
    setProcessBtListener() {
        for(let i=0, n=this.processTypeArray.length; i<n; i++) {
            MyUtility.setElementEvent( 'process-'+i, 'click', () => this.processBtClick( i ) );
        };
    };
    processBtClick(index) {
        MyUtility.setFillArray( this.processTypeArray, false);
        this.processTypeArray[index] = true;
        this.setCustomBtSttyle( 'process', this.processTypeArray);
    };
    


    //  customNext 
    customNextProcess(isPick30=true, isState=true) {

        this.useData['custom-jiku'] = this.jikuBoo;
        this.useData['custom-jyo'] = this.jyoBoo;

        let target = this.targetArray[ this.targetBooArray.findIndex( (val) => val ) ];
        this.useData['target-size'] = target;

        this.useData['processValue'] = this.processTypeValueArray[ this.processTypeArray.findIndex( (val) => val ) ];


        this.conveniPool.setDataObj(this.useData);

        this.conveniPool.totalDefDupBooForCustom();

        if(isPick30) {
            let pickup30 = this.conveniPool.makePickup30Array();

            this._pick3Array = this.conveniPool.pickup3( pickup30, 0);
    
            this._canvas.setPick3( this._pick3Array );
        };

        if(isState) {
            MyUtility.setElementStyle('custom', 'display', 'none');
            MyUtility.setElementStyle('pred', 'display', 'block');
    
            this._conveniStateObj.customJiku = this.jikuBoo;
            this._conveniStateObj.customJyo = this.jyoBoo;
            this._conveniStateObj.targetBoo = this.targetBooArray;
            this._conveniStateObj.justBoo = this.isJustTargetArray;

            this._conveniStateObj.process = this.processTypeArray;

            MyUtility.setFillArray(this._VIEW_STATE_BOO, false);
            this._VIEW_STATE_BOO[2] = true;
            this._conveniStateObj.viewState = this._VIEW_STATE_BOO;
            try {
                StorageOperator.setStorageData( 'session', 'conveni-state', this._conveniStateObj );
            }catch(exeption) {
                //alert('お使いのブラウザでは、本サイトは正常に動作しない可能性があります');
            };
        };

        window.scroll(0, 110);
    };
    //

    predictPick3Choice(index) {

        let size = this._pick3Array.length;
        if( size > index ) {
            let newCont3 = this.conveniPool.pickup3Choice( this._pick3Array[index] );
            if(newCont3) {
                this._pick3Array = newCont3;
                this._canvas.setPick3( newCont3 );
            }else {

                this.setResultList();
            };
        };
    };
    predictPassBtProcess() {
        let newCont3 = this.conveniPool.predictPassProcess( this._pick3Array );
        this._pick3Array = newCont3;
        this._canvas.setPick3( newCont3 );
    };
    predictReturnBtProcess() {
        let newCont3 = this.conveniPool.predictReturnProcess();
        this._pick3Array = newCont3;
        this._canvas.setPick3( newCont3 );
    };



    //
    //  result
    setResultList() {

        let resultList = this.conveniPool.makeResultList(this.isJustTargetArray[0], this.targetArray[ this.targetBooArray.findIndex( (val) => val ) ]);
        this.setResultTable( resultList );

        this.setResultListSize( resultList );

        //  state
        this._conveniStateObj.resultList = resultList;
        MyUtility.setFillArray(this._VIEW_STATE_BOO, false);
        this._VIEW_STATE_BOO[3] = true;
        this._conveniStateObj.viewState = this._VIEW_STATE_BOO;
        
        try {
            StorageOperator.setStorageData( 'session', 'conveni-state', this._conveniStateObj );
        }catch(exeption) {
            //alert('お使いのブラウザでは、本サイトは正常に動作しない可能性があります');
        };

        this.setViewDiv();
        window.scroll(0, 124);
    };

    setResultTable( resultList ) {

        let result_td = document.getElementById('result-td');
        let frag = document.createDocumentFragment();
        for(let i=0, n=resultList.length; i<n; i++) {

            let numb = resultList[i];
            let ndA = document.createElement( 'a' );
            ndA.appendChild( document.createTextNode( numb ) );
			ndA.className='box-text';
			let nb34 = 'nb'+numb.length;
            ndA.href = '../numb-box/'+nb34+'/'+nb34+'-box-'+numb+'.html';

            let sp = '';
            if(i<n-1) {   sp = ', ';   }
            frag.appendChild( ndA );
			frag.appendChild( document.createTextNode( sp ) );
        };

        let child = result_td.lastChild;
        while( child ) {
            result_td.removeChild(child);
            child = result_td.lastChild;
        };
        
        result_td.appendChild( frag );
    };

    setResultListSize(resultList) {
        let size = resultList.length;
        let td_size = document.getElementById( 'result-size' );

        let child = td_size.lastChild;
        while( child ) {
            td_size.removeChild(child);
            child = td_size.lastChild;
        };
        td_size.appendChild( document.createTextNode(size) );
    };


    //
    //  return
    returnProcess() {
        if(this._VIEW_STATE_BOO[0]) {

            history.back();

        }else if(this._VIEW_STATE_BOO[1]) {

            this.setViewStateBoo(0);
            this.setReturnProcessStorage();
            this.setViewDiv();

        }else if(this._VIEW_STATE_BOO[2]) {

            this.setViewStateBoo(1);
            this.setReturnProcessStorage();
            this.conveniPool.predictChoiceClear();
            this.setViewDiv();

        }else if(this._VIEW_STATE_BOO[3]) {

            this.setViewStateBoo(1);
            this.setReturnProcessStorage();
            this.conveniPool.predictChoiceClear();
            this.setViewDiv();
        };
    };

    setReturnProcessStorage() {
        this._conveniStateObj.viewState = this._VIEW_STATE_BOO;
        try {
            StorageOperator.setStorageData( 'session', 'conveni-state', this._conveniStateObj );
        }catch(exeption) {
            //alert('お使いのブラウザでは、本サイトは正常に動作しない可能性があります');
        };
    };


    //  theme
    themeChange() {
        let array = this._canvas._themeArray;
        let index = this._canvas._themeIndex;
        this._canvas._themeIndex = (++index)%array.length;
        this._canvas.setTheme();

		let boo = [true, true];
		try {
			boo = StorageOperator.storageSetProperty( 'theme', this._canvas._themeIndex );
		}catch(exeption) {
			//alert('お使いのブラウザでは、本サイトは正常に動作しません');
		};
    };

};




class ConveniCanvas {

    constructor(themeIndex=0) {

        //  テーマ
		this._THEME_0 = { numb: 0,  white: 'white', back: 'rgba(92,168,239,1)', gradaB: [ 92,168,239 ],
                gradaItv: [ 32, 17, 3 ], back2: 'rgb(62, 148, 242)', graphBack: 'rgba(105, 188, 255, 0.85)',
                strokeLine: 'rgba(5, 25, 255, 0.8)', strokeGraphF: 'rgba(37, 53, 111, 0.95)',
                graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
                movingA_S: 'rgb(210, 85, 10)',  movingA_M: 'rgb( 255, 255, 255)',
                movingA_L: 'rgb(255,255,0)'  };

        this._THEME_1 = { numb: 1,  white: 'white', back: 'rgba(50,50,50,1)', gradaB: [ 50,50,50 ],
                gradaItv: [ 40, 40, 40 ], back2: 'rgb(25, 25, 25)', graphBack: 'rgba(70, 70, 70, 1)',
                strokeLine: 'rgba(10, 10, 10, 1)', strokeGraphF: 'rgba(5, 5, 5, 1)',
                graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
                movingA_S: 'rgb(10, 130, 240)',  movingA_M: 'rgb( 255, 255, 255)',
                movingA_L: 'rgb(230,230,0)'  };

        this._THEME_2 = { numb: 2,  white: 'rgb(30,30,30)', back: 'rgba(230,230,245,1)', gradaB: [ 240,240,255 ],
                gradaItv: [ -48, -48, -50 ], back2: 'rgb(215, 215, 235)', graphBack: 'rgba(180, 180, 200, 1)',
                strokeLine: 'rgba(10, 10, 10, 1)', strokeGraphF: 'rgba(145, 145, 205, 1)',
                graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
                movingA_S: 'rgb(10, 130, 240)',  movingA_M: 'rgb( 255, 255, 255)',
                movingA_L: 'rgb(255,255,0)'  };

        this._themeArray = [   this._THEME_0, this._THEME_1, this._THEME_2   ];
        this._themeIndex = themeIndex;
        this.setTheme( false );
        //this._THEME = this._themeArray[ this._themeIndex ];
        //this._setThemeColor();

    };


    setTheme( isPaint = true ) {

        this._THEME = this._themeArray[ this._themeIndex ];
        this._setThemeColor();
        if(isPaint) {  this.paint();  }
        MyUtility.setElementStyle( 'centerLi_0', 'background-color', this._fillStyleBack );
        MyUtility.setElementStyle( 'centerLi_0', 'border-color', this._styleWhite );
        MyUtility.setElementStyle( 'canvasBt-table', 'background-color', this._fillStyleBack );
        MyUtility.setElementStyle( 'canvasBt-table-2', 'background-color', this._fillStyleBack );
        MyUtility.setElementStyle( 'theme-bt', 'background-color', this._fillStyleBack );
        MyUtility.setElementStyle( 'theme-bt', 'color', this._styleWhite );
        MyUtility.setElementStyle( 'theme-bt', 'border-color', this._styleWhite );

    };

    _setThemeColor() {

		this._styleWhite = this._THEME.white;
		this._fillStyleBack = this._THEME.back;
		this._gradationBase = this._THEME.gradaB;
		this._gradationItv = this._THEME.gradaItv;

		this._fillStyleBack2 = this._THEME.back2;
		this._fillStyleGraphBack = this._THEME.graphBack;

		this._strokeStyleLine = this._THEME.strokeLine;

		this._strokeStyleCenterGraphFrame = this._THEME.strokeGraphF;
		this._fillStyleCenterGraphUp = this._THEME.graphUp;
		this._fillStyleCenterGraphDown = this._THEME.graphDown;

		this._movingA_S = this._THEME.movingA_S;
		this._movingA_M = this._THEME.movingA_M;
		this._movingA_L = this._THEME.movingA_L;

	};


    setPick3( pick3 ) {
        this._pick3 = pick3;
        this.paint();
    };

    paint() {

        let pick3 = this._pick3;

		let canvas = document.getElementById( 'canvas' );

		if (canvas.getContext) {

			let context = canvas.getContext('2d');

			//  画面クリア
			context.fillStyle = this._fillStyleBack;
            context.fillRect(0, 0, 320, 450);

            
            context.fillStyle = this._fillStyleBack2;
            for(let i=0; i<3; i++) {
                for(let j=0; j<4; j++) {
                    context.fillRect(35+(i*95), 5+(j*100), 90, 50);
                }; 
            }

            //  枠
			context.strokeStyle = this._styleWhite;
			context.strokeRect(35, 5, 90, 400);
            context.strokeRect(130, 5, 90, 400);
            context.strokeRect(225, 5, 90, 400);


			//テキスト描画のスタイルを指定
			context.fillStyle = this._styleWhite;
			context.font = "13px 'Meiryo'";
			context.textAlign = "left";
            context.textBaseline = "top";
            

            let pick3Size = pick3.length;

            if(pick3Size >= 1) {
                let arr = pick3[0].booArray;
                this._leftNumbPaint( context, 0, arr.length-40, 40 );
                this._leftRectPaint( context, 0, arr, arr.length-40, 40, 0 );

                let per = pick3[0].predData.get('percent');
                this.percentPaint( context, per, 0 );
            };
            if(pick3Size >= 2) {
                let arr = pick3[1].booArray;
                this._leftRectPaint( context, 0, arr, arr.length-40, 40, 1 );

                let per = pick3[1].predData.get('percent');
                this.percentPaint( context, per, 1 );
            };
            if(pick3Size===3) {
                let arr = pick3[2].booArray;
                this._leftRectPaint( context, 0, arr, arr.length-40, 40, 2 );

                let per = pick3[2].predData.get('percent');
                this.percentPaint( context, per, 2 );
            };
            
            

            /*
			//  オフセットブロック size
			let offsetBkSize = this.canvasViewRange/500*400;
			//  左オフセットブロック
			context.fillRect(120, 6+zz*0.8, 7, offsetBkSize);
			//  右オフセットブロック
			context.fillRect(165, 5+Math.floor(zz/5)*4, 7, offsetBkSize);
			//
			let arr = this._booArr500;
			let indStart = this._indexStart;

			this._leftViewPaint(context, zz, arr, indStart);


			context.font = "13px 'Meiryo'";
			context.fillText((indStart+501)+"           ?", 10, 415, 165);
			context.fillRect(70, 417, 15, 15);

			//
			context.font = "14px 'Meiryo'";

			context.fillRect(190, 221, 15, 15);
			context.fillText("率", 216, 219, 20);

			context.fillText( this._percent+"%", 210, 240, 60);

			context.fillText( "選択後" , 190, 270, 40);
			context.fillText( "B", 200, 300, 40);     context.fillText( "S", 200, 350, 40);

			context.textAlign = "center";

			for(let i=0, n=this._totalCountArray.length; i<n; i++) {
				let bar = 0.5;
				if(i>1) {  bar = 10.5;  }
				context.fillText( this._totalCountArray[i], 243, 290+(i*21)+bar, 50);
			};

			//
			context.beginPath();
			context.moveTo(221, 310.5);
			context.lineTo(265, 310.5);

			context.moveTo(221, 362);
			context.lineTo(265, 361);
			context.stroke();
			context.closePath();
			//



			let arrayMeta = this._booArr500Itv5;
			for(let i=0; i<arrayMeta.length; i++) {
				let ct = arrayMeta[i];

				this._paintRect(ct, context);

				context.fillRect(145, 5+i*4, 15, 4);
			};

			for(let i=0; i<6; i++) {

				this._paintRect(i, context);

				context.fillRect(180, 19.5+i*20, 15, 10);

				context.fillStyle = this._styleWhite;
				context.fillText(i, 207, 14+i*20, 16);
			};
			context.strokeRect(179.5, 19, 16, 11);
            //
            
            */
		};  //  if
    };
    

    _leftNumbPaint( context, zz, indStart, range ) {
    
		let boxRange = 400/range;

		let fontSizeSub = range/50;
		let fontSize = Math.floor(boxRange*(0.25+fontSizeSub));

		context.font = fontSize+"px 'Meiryo'";

		for(let i=0; i<range; i++) {
			context.fillText((i+zz+indStart+1), 7, 4.5+i*boxRange, 55);
        };

        context.font = "12px 'Meiryo'";
        context.fillText((indStart+range+1), 5, 408, 55);

        context.font = "14px 'Meiryo'";
        context.fillText( '確率', 8, 430, 55);
        
	};

    _leftRectPaint( context, zz, arr, indStart, range, windowIndex ) {

		let boxRange = 400/range;
		let big = boxRange*0.75;
		let sml = boxRange*0.15;
		let bigG = (boxRange-big)/2;
		let smlG = (boxRange-sml)/2;

		let rangeX = boxRange/2;

		let fontSizeSub = range/50;
		let fontSize = Math.floor(boxRange*(0.25+fontSizeSub));

		context.font = fontSize+"px 'Meiryo'";

		for(let i=0; i<range; i++) {

			if(arr[i+zz+indStart]===0) {
				context.fillRect(78+smlG-rangeX+(windowIndex*95), 5+smlG+i*boxRange, sml, sml);
			}else {
				context.fillRect(78+bigG-rangeX+(windowIndex*95), 5+bigG+i*boxRange, big, big);
            };
        };
        
        context.fillRect(78+bigG-rangeX+(windowIndex*95), 413, big, big);

        context.font = "12px 'Meiryo'";
        context.fillText( '?', 90+(windowIndex*95), 408, 55);
    };
    
    percentPaint( context, percent, windowIndex ) {

        context.font = "14px 'Meiryo'";
        context.fillText( percent+'%', 55+windowIndex*95, 430, 55);
    };


};